import RichTextInput from './RichTextInput'
import MarginOptions from './MarginOptions'
import MaxWidthOptions from './MaxWidthOptions'
import RightBarGroup from './RightBarGroup'
import {
  FontWeightOptions,
  TextAlignmentOptions,
  TextColorOptions,
} from './TypographyOptions'
import {
  ChangeEvent,
  DynamicContentType,
  RichTextData,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  setData: (e: ChangeEvent) => void
  content: DynamicContentType<RichTextData>
}

const RichTextEditor = ({ setData, content }: Props) => {
  const { tr } = useTr()
  return (
    <>
      <RichTextInput value={content.data.html} name='html' onChange={setData} />
      <br />
      <RightBarGroup title={tr(TrKey.textSettings)} topLine>
        <TextAlignmentOptions content={content} setData={setData} />
        <TextColorOptions content={content} setData={setData} />
        <FontWeightOptions content={content} setData={setData} />
        <MaxWidthOptions content={content} setData={setData} />
      </RightBarGroup>
      <MarginOptions content={content} setData={setData} />
    </>
  )
}

export default RichTextEditor
